"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomInt = exports.percentCalc = exports.addKsuffix = exports.digitsToLatin = exports.digitsToHindi = void 0;
exports.toMoneyFormat = toMoneyFormat;
exports.fromMoneyFormats = fromMoneyFormats;
const digitsToHindi = (number) => {
    var _a;
    const hindiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return ((_a = number === null || number === void 0 ? void 0 : number.replace(/[0-9]/g, function (w) {
        return hindiDigits[Number(w)];
    })) !== null && _a !== void 0 ? _a : "");
};
exports.digitsToHindi = digitsToHindi;
const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
];
const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
];
const digitsToLatin = (inputNumber) => {
    let result = inputNumber;
    if (typeof result === "string") {
        new Array(10).fill(0).map((e, index) => {
            result = result
                .replace(persianNumbers[index], String(index))
                .replace(arabicNumbers[index], String(index));
        });
    }
    return result;
};
exports.digitsToLatin = digitsToLatin;
function toMoneyFormat(value) {
    const v = value.replace(/,/g, "");
    if (!v)
        return "";
    if (v.length < 3)
        return v;
    return v.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}
function fromMoneyFormats(value) {
    const v = value.replace(/,/g, "");
    if (!v)
        return "";
    if (v === "0" || v === "۰") {
        return v;
    }
    return v.replace(/^[0۰]+/g, "");
}
// 1000 => 1k
const addKsuffix = (number, options) => {
    if (number < 1000)
        return (0, exports.digitsToHindi)(number.toString());
    if ((options === null || options === void 0 ? void 0 : options.decimalPlaces) === undefined)
        return (0, exports.digitsToHindi)((number / 1000).toString()) + "k";
    const factor = Math.pow(10, options.decimalPlaces);
    return ((0, exports.digitsToHindi)(parseFloat((Math.floor((number / 1000) * factor) / factor).toFixed(options.decimalPlaces)).toString()) + "k");
};
exports.addKsuffix = addKsuffix;
// (1,5) => 20%
const percentCalc = (numerator, denominator) => {
    return ((numerator / (denominator || 1)) * 100).toFixed(2).concat("%");
};
exports.percentCalc = percentCalc;
const getRandomInt = () => {
    return Math.floor(Math.random() * 0xffffffff);
};
exports.getRandomInt = getRandomInt;
//# sourceMappingURL=numbers.js.map